import type { FirestoreDataConverter } from 'firebase/firestore'
import { fromFirestore, toFirestore } from '~/firestore/converters/converter'
import type { SimulatorCourse, SimulatorCourseDocument } from '~/types/simulator/simulator'

export const simulatorCourseConverter: FirestoreDataConverter<
    SimulatorCourse,
    SimulatorCourseDocument
> = {
    fromFirestore,
    toFirestore,
}
